module.exports = __webpack_public_path__ + "static/media/0030_IMG_LES_STRUCTURES_ILV.0d258f01.png";